module.exports = __webpack_public_path__ + "static/media/playchess.8d16f56e.png";